import { defineComponent } from "vue";
export default defineComponent({
    // #region Vars
    name: 'g-cloudflare-turnstile',
    // #endregion
    // #region Events
    emits: ['update:modelValue', 'error', 'unsupported', 'expired', 'before-interactive', 'after-interactive'],
    // #endregion
    // #region Properties
    props: {
        siteKey: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            required: false,
        },
        resetInterval: {
            type: Number,
            required: false,
            default: 295 * 1000,
        },
        size: {
            type: String,
            required: false,
            default: 'normal',
        },
        theme: {
            type: String,
            required: false,
            default: 'auto',
        },
        language: {
            type: String,
            required: false,
            default: 'auto',
        },
        action: {
            type: String,
            required: false,
            default: '',
        },
        appearance: {
            type: String,
            required: false,
            default: 'always',
        },
        renderOnMount: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        resetTimeout: undefined,
        widgetId: undefined,
    }),
    computed: {
        hasTurnstile() {
            return !utils.isNullOrEmpty(this.siteKeyTurnstile);
        },
        siteKeyTurnstile() {
            return this.siteKey ?? this.$appHost.options.get('cloudflare_turnstile_key');
        },
        turnstileOptions() {
            return {
                sitekey: this.siteKeyTurnstile,
                theme: this.theme,
                language: this.language,
                size: this.size,
                callback: this.callback,
                action: this.action,
                appearance: this.appearance,
                'error-callback': this.errorCallback,
                'expired-callback': this.expiredCallback,
                'unsupported-callback': this.unsupportedCallback,
                'before-interactive-callback': this.beforeInteractiveCallback,
                'after-interactive-callback': this.afterInteractivecallback,
            };
        },
        turnstile() {
            return window.turnstile;
        }
    },
    // #endregion
    // #region Constructor
    created() {
    },
    async mounted() {
        if (!this.hasTurnstile) {
            return;
        }
        try {
            //Load
            await appHost.pageMeta.loadScript(`https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit`);
            //Render
            if (this.renderOnMount) {
                this.render();
            }
        }
        catch (e) {
            return;
        }
    },
    beforeUnmount() {
        //Remove
        this.remove();
        clearTimeout(this.resetTimeout);
    },
    // #endregion
    // #region Methods
    methods: {
        afterInteractivecallback() {
            this.$emit('after-interactive');
        },
        beforeInteractiveCallback() {
            this.$emit('before-interactive');
        },
        expiredCallback() {
            this.$emit('expired');
        },
        unsupportedCallback() {
            this.$emit('unsupported');
        },
        errorCallback(code) {
            this.$emit('error', code);
        },
        callback(token) {
            this.$emit('update:modelValue', token);
            this.startResetTimeout();
        },
        reset() {
            if (this.turnstile) {
                this.$emit('update:modelValue', '');
                this.turnstile.reset();
            }
        },
        remove() {
            if (this.widgetId) {
                this.turnstile?.remove(this.widgetId);
                this.widgetId = undefined;
            }
        },
        render() {
            this.widgetId = this.turnstile?.render(this.$refs.turnstile, this.turnstileOptions);
        },
        startResetTimeout() {
            this.resetTimeout = setTimeout(() => { this.reset(); }, this.resetInterval);
        },
    },
    // #endregion
});
